import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toggleApplyPenaltyFee } from '../../redux/modules/registration';
import renewalPenaltyTotal from '../../selectors/renewalPenaltyTotal.selector';

class PenaltyFee extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { penaltyFee, applyPenaltyFee } = this.props;
    return (
      <div className="Row Registration-plateFeeRow">
        <input tabIndex="-1" className="Row-total" data-id="penaltyTotal" id="Rsub2" data-tooltip="Plate Issue Fees Total including all County, if applicable" type="text" value={applyPenaltyFee ? penaltyFee : '0.00'} readOnly />
        <input className="no-print" id="Penaltybox" data-tooltip="Check to apply penalty fees for this vehicle." type="checkbox" checked={applyPenaltyFee && Number(penaltyFee) > 0} onChange={this.props.toggleApplyPenaltyFee} />
        <label className="no-print" htmlFor="Penaltybox">Apply renewal penalty amount</label>
        <b className="print-label print-only">Renewal Penalty</b>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    penaltyFee: renewalPenaltyTotal(state),
    applyPenaltyFee: state.registration.applyPenaltyFee,
  };
};

export default connect(mapStateToProps, { toggleApplyPenaltyFee })(PenaltyFee);



// WEBPACK FOOTER //
// ./src/containers/registration/PenaltyFee.js